export default "__VITE_ASSET__a24bf191__"